var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-edit-content" }, [
    _vm.value.ext.edit
      ? _c(
          "span",
          _vm._l(_vm.levels, function (item, ind) {
            return _c(
              "div",
              { key: ind, staticClass: "edit" },
              [
                _c("div", { staticClass: "area-title" }, [
                  _vm._v(_vm._s(item.label)),
                ]),
                _vm._v(" "),
                item.value !== "province"
                  ? _c("vh-switch", {
                      staticClass: "remove",
                      attrs: {
                        "active-color": "#FB3A32",
                        "inactive-color": "#CECECE",
                        size: "mini",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeValue(item)
                        },
                      },
                      model: {
                        value: item.isRemove,
                        callback: function ($$v) {
                          _vm.$set(item, "isRemove", $$v)
                        },
                        expression: "item.isRemove",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isReplay
      ? _c("div", { staticClass: "select" }, [
          !_vm.value.ext.edit
            ? _c(
                "div",
                { staticClass: "q-edit-select vhall-inline" },
                [
                  _c(
                    "vh-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("form.form_1004"),
                        size: "small",
                      },
                      on: {
                        change: _vm.changeProvince,
                        focus: _vm.focusProvince,
                      },
                      model: {
                        value: _vm.provinceVal,
                        callback: function ($$v) {
                          _vm.provinceVal = $$v
                        },
                        expression: "provinceVal",
                      },
                    },
                    _vm._l(_vm.provinces, function (item, index) {
                      return _c("vh-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.value.ext.edit && _vm.showCity
            ? _c(
                "div",
                { staticClass: "q-edit-select vhall-inline" },
                [
                  _c(
                    "vh-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("form.form_1005"),
                        size: "small",
                      },
                      on: { change: _vm.changeCity, focus: _vm.focusCity },
                      model: {
                        value: _vm.cityVal,
                        callback: function ($$v) {
                          _vm.cityVal = $$v
                        },
                        expression: "cityVal",
                      },
                    },
                    _vm._l(_vm.cities, function (item, index) {
                      return _c("vh-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.value.ext.edit && _vm.showCounty
            ? _c(
                "div",
                { staticClass: "q-edit-select vhall-inline" },
                [
                  _c(
                    "vh-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("form.form_1006"),
                        size: "small",
                      },
                      on: { focus: _vm.focusCounty },
                      model: {
                        value: _vm.countyVal,
                        callback: function ($$v) {
                          _vm.countyVal = $$v
                        },
                        expression: "countyVal",
                      },
                    },
                    _vm._l(_vm.counties, function (item, index) {
                      return _c("vh-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.value.ext.edit && _vm.showAddress && !_vm.isReplay
      ? _c(
          "div",
          { staticClass: "q-edit-select" },
          [
            _c("com-input", {
              attrs: {
                placeholder: _vm.$t("form.form_1042"),
                disabled: _vm.value.ext.edit,
                "max-length": 100,
              },
              on: { focus: _vm.focusAddress },
              model: {
                value: _vm.value.address,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "address", $$v)
                },
                expression: "value.address",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isReplay
      ? _c(
          "div",
          { staticClass: "q-edit-select disabled" },
          [
            _c("com-input", {
              attrs: { disabled: true },
              model: {
                value: _vm.address,
                callback: function ($$v) {
                  _vm.address = $$v
                },
                expression: "address",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.value.ext.edit && _vm.errorTip
      ? _c("div", { staticClass: "error-msg" }, [
          _vm._v("\n    " + _vm._s(_vm.errorTip) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }